import { appConfig } from "@/config/app-config"

export const composePageTitle = (pageTitle: string) => {
  return appConfig.titleTemplate.replace("{{pageTitle}}", pageTitle)
}
